import { useEffect, useState } from "react";
import { Paperclip } from "lucide-react";
import { api } from "@/lib/api";

export const EmailPreview = ({ tid, fromName, to, cc, subject, message, filename }) => {
  const [mail, setMail] = useState(null);
  useEffect(() => {
    const h = setTimeout(() => { api.post("/docs/email-preview", { message, tid, from_name: fromName || null }).then((r) => setMail(r.data)).catch(() => setMail(null)); }, 250);
    return () => clearTimeout(h);
  }, [message, tid, fromName]);
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white" data-testid="doc-email-preview">
      <div className="space-y-1 border-b border-slate-100 bg-slate-50 px-4 py-3 text-xs text-slate-600">
        <p><span className="font-semibold text-slate-800">De:</span> <span data-testid="doc-email-preview-from">{mail?.from_name || "…"}</span></p>
        <p className="break-all"><span className="font-semibold text-slate-800">Para:</span> {[to, cc].filter((x) => x && x.trim()).join(", ")}</p>
        <p><span className="font-semibold text-slate-800">Asunto:</span> <span data-testid="doc-email-preview-subject">{subject}</span></p>
        <p className="flex items-center gap-1 pt-1 text-slate-700" data-testid="doc-email-preview-attachment"><Paperclip size={12} />{filename || "Documento.pdf"}</p>
      </div>
      {mail ? <iframe title="Vista previa del correo" srcDoc={mail.html} sandbox="" className="block h-[340px] w-full bg-[#F5F6F8]" data-testid="doc-email-preview-frame" />
        : <div className="h-[340px] animate-pulse bg-slate-100" />}
    </div>
  );
};
